<script>
	import UIIcon from "./UIIcon.svelte";
	import view from "../stores/view";

	import base from "../stores/base";
	import router from "../stores/router";
	import { fly } from "svelte/transition";

	let isOpen = false;
	let node;

	$: {
		$router.path;
		isOpen = false;
	}

	// 後ろを触ったらメニューを閉じる
	function onPressBody(e) {
		if (!node || !node.contains(e.target)) {
			isOpen = false;
		}
	}
</script>

<svelte:body on:mousedown={onPressBody} on:touchstart={onPressBody} />
<div class="UICagegory" bind:this={node}>
	<button
		class="UICagegory-btn"
		on:click={() => (isOpen = !isOpen)}
		class:_open={isOpen}
	>
		<span
			>{{ ja: "カテゴリーを選択", en: "Category" }[
				$base.lang
			]}</span
		>
		<span>
			<UIIcon
				type="down"
				color="#fff"
				size={$view.mode === "pc" ? 24 : 20}
			/>
		</span>
	</button>
	{#if isOpen}
		<nav transition:fly={{ y: -10, duration: 200 }}>
			{#each $base.categoryMenu as id}
				<a
					href={"/" + id}
					on:click|preventDefault={() => router.push("/" + id)}
					class:_selected={$router.params.category === id}
					><span>{$base.categories[id][$base.lang]}</span></a
				>
			{/each}
		</nav>
	{/if}
</div>

<style global>
	.UICagegory {
		position: relative;
		width: 240px;
		margin: 0 auto;
	}
	.UICagegory-btn {
		border: 1px solid #fff;
		color: #fff;
		font-size: 1.125em;
		padding: 0.3em 2em;
		background-color: rgb(0, 0, 0, 0.33);
		display: inline-block;
		position: relative;
		width: 100%;
		cursor: pointer;
	}
	.UICagegory-btn:focus-visible {
		border: 1px dashed #fff;
	}
	.UICagegory-btn span {
		display: inline-block;
	}
	.UICagegory-btn svg {
		position: absolute;
		top: 50%;
		bottom: 50%;
		right: 0.3em;
		margin: auto;
		transition: transform 100ms ease-out;
	}
	.UICagegory-btn._open svg {
		transform: rotate(-180deg);
	}
	.UICagegory > nav {
		position: absolute;
		top: 4em;
		width: 100%;
		background: #fff;
		box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
	}
	.UICagegory > nav:before {
		content: "";
		position: absolute;
		top: -25px;
		left: 50%;
		margin-left: -13px;
		border: 13px solid transparent;
		border-bottom: 13px solid #fff;
	}
	.UICagegory > nav > a {
		display: block;
		text-align: center;
		color: #bb5858;
		padding: 0.5em;
		border-bottom: 1px solid rgba(160, 40, 40, 0.1);
	}
	.UICagegory > nav > a:first-child {
		border-bottom: 1px solid #fff;
	}
	.UICagegory > nav > a:focus {
		background: #f5eaea;
		border-bottom: 1px dashed #bb5858;
	}

	.UICagegory > nav > a._selected {
		background: #bb5858;
		color: #fff;
	}
</style>
